import { MyUnapprovedTravelSheetsComponent } from './travel-sheet/my-unapproved-travel-sheets/my-unapproved-travel-sheets.component';
import { ManageAnnouncementComponent } from './organization-setup/manage-announcement/manage-announcement.component';
import { MyUnapprovedDiariesComponent } from './manage-diary/my-unapproved-diaries/my-unapproved-diaries.component';
import { MyArticleOneSixthReportComponent } from './standard-reports/my-article-one-sixth-report/my-article-one-sixth-report.component';
import { ArticleOneSixthReportComponent } from './hr-report/article-one-sixth-report/article-one-sixth-report.component';
import { MyPenaltySummaryComponent } from './standard-reports/my-penalty-summary/my-penalty-summary.component';
import { MyEmployeeComponent } from './hr-report/independence/my-employee/my-employee.component';
import { MyClientComponent } from './hr-report/independence/my-client/my-client.component';
import { MyAnnualComponent } from './hr-report/independence/my-annual/my-annual.component';
import { MyAllClientComponent } from './hr-report/independence/my-all-client/my-all-client.component';
import { ClientBillingComponent } from './human-resource/client-billing/client-billing.component';
import { CompanyConfigComponent } from './organization-setup/company-config/company-config.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { ManageAssignmentComponent } from './master-data/manage-assignment/manage-assignment.component';
import { ManageTaskComponent } from './master-data/manage-task/manage-task.component';
import { ManageBranchComponent } from './master-data/manage-branch/manage-branch.component';
import { ManageFinancialYearComponent } from './master-data/manage-financial-year/manage-financial-year.component';
import { ManageDRoleComponent } from './master-data/manage-d-role/manage-d-role.component';
import { ManageDesignationComponent } from './master-data/manage-designation/manage-designation.component';
import { ManageLocationComponent } from './master-data/manage-location/manage-location.component';
import { ConveyanceRatesComponent } from './organization-setup/conveyance-rates/conveyance-rates.component';
import { StandardRatesComponent } from './organization-setup/standard-rates/standard-rates.component';
import { ClientComponent } from './organization-setup/client/client.component';
import { BranchHolidaysComponent } from './organization-setup/branch-holidays/branch-holidays.component';
import { ArticleStipendComponent } from './organization-setup/article-stipend/article-stipend.component';
import { ProfileComponent } from './human-resource/profile/profile.component';
import { MyDiaryComponent } from './manage-diary/my-diary/my-diary.component';
import { MyPendingApprovalComponent } from './manage-diary/my-pending-approval/my-pending-approval.component';
import { MyPendingSubmissionComponent } from './manage-diary/my-pending-submission/my-pending-submission.component';
import { MyLeavesComponent } from './user-details/my-leaves/my-leaves.component';
import { CtcDetailsComponent } from './user-details/ctc-details/ctc-details.component';
import { OfficialDetailsComponent } from './user-details/official-details/official-details.component';
import { PersonalDetailsComponent } from './user-details/personal-details/personal-details.component';
import { ManpowerBudgetComponent } from './organization-setup/manpower-budget/manpower-budget.component';

import { DiaryDetailsComponent } from './hr-report/diary-details/diary-details.component';
import { MyDiariesComponent } from './standard-reports/my-diaries/my-diaries.component';
import { MyLeavesDetailsComponent } from './standard-reports/my-leaves-details/my-leaves-details.component';
import { EmpLeaveSummaryComponent } from './hr-report/emp-leave-summary/emp-leave-summary.component';

import { ComponentCanDeactivateGuard } from './guard/component.can-deactivate.guard';
import { SalaryComponent } from './account-report/salary/salary.component';
import { StipendComponent } from './account-report/stipend/stipend.component';
import { PenaltySummaryComponent } from './hr-report/penalty-summary/penalty-summary.component';
import { AnnualComponent } from './analytic-report/independence/annual/annual.component';
import { ClientIndependenceComponent } from './analytic-report/independence/client/client.component';
import { EmployeeComponent } from './analytic-report/independence/employee/employee.component';
import { AllClientComponent } from './analytic-report/independence/all-client/all-client.component';
import { BudgetComponent } from './analytic-report/budget/budget.component';
import { MySalaryClosingComponent } from './standard-reports/my-salary-closing/my-salary-closing.component';
import { EmpanelmentReportComponent } from './hr-report/empanelment-report/empanelment-report.component';
import { ClientConveyanceSummaryComponent } from './account-report/client-conveyance-summary/client-conveyance-summary.component';
import { ClientConveyanceAssignmentComponent } from './account-report/client-conveyance-assignment/client-conveyance-assignment.component';
import { MyStipendReportComponent } from './standard-reports/my-stipend-report/my-stipend-report.component';
import { MonthlyConveyanceReportComponent } from './account-report/monthly-conveyance-report/monthly-conveyance-report.component';
import { MonthlyConveyanceDetailReportComponent } from './account-report/monthly-conveyance-detail-report/monthly-conveyance-detail-report.component';
import { OvertimeReportComponent } from './hr-report/overtime-report/overtime-report.component';
import { ArticleAvailabilityReportComponent } from './hr-report/article-availability-report/article-availability-report.component';
import { AuthGuard } from './guard/auth.guard';
import { DocumentListComponent } from './document-management-details/document-list/document-list.component';
import { DocumentManagementComponent } from './document-management-details/document-management/document-management.component';
import { CreateFolderComponent } from './document-management-details/create-folder/create-folder.component';
import { DocumentFolderMenuComponent } from './document-management-details/document-folder-menu/document-folder-menu.component';
import { TravelSheetComponent } from './travel-sheet/travel-sheet/travel-sheet.component';
import { MyPendingTravelSheetApprovalsComponent } from './travel-sheet/my-pending-travel-sheet-approvals/my-pending-travel-sheet-approvals.component';
import { SubmittedSheetsComponent } from './travel-sheet/submitted-sheets/submitted-sheets.component';
import { BudgetVsActualCostReportComponent } from './analytic-report/budget-vs-actual-cost-report/budget-vs-actual-cost-report.component';
import { BankPaymentReportComponent } from './account-report/bank-payment-report/bank-payment-report.component';
import { SalarySlipReportComponent } from './account-report/salary-slip-report/salary-slip-report.component';
import { ArticleDebitCreditHoursComponent } from './hr-report/article-debit-credit-hours/article-debit-credit-hours.component';
import { AllIndependenceDeclarationComponent } from './analytic-report/independence/all-independence-declaration/all-independence-declaration.component';
import { MyAllIndependenceDeclarationComponent } from './hr-report/independence/my-all-independence-declaration/my-all-independence-declaration.component';
import { AnnualSalaryReportComponent } from './account-report/annual-salary-report/annual-salary-report.component';
import { ExitFormComponent } from './user-details/exit-form/exit-form.component';
import { ExitFormSummaryComponent } from './user-details/exit-form-summary/exit-form-summary.component';
import { AnnualStipendReportComponent } from './account-report/annual-stipend-report/annual-stipend-report.component';
import { ExpenseReimbursementReportComponent } from './account-report/expense-reimbursement-report/expense-reimbursement-report.component';
import { MyActualTaskReportComponent } from './analytic-report/my-actual-task-report/my-actual-task-report.component';
import { SoftwareAssetsComponent } from './asset-management/software-assets/software-assets.component';
import { HardwareAssetsComponent } from './asset-management/hardware-assets/hardware-assets.component';
import { AssetsPhysicalVerificationReportComponent } from './account-report/assets-physical-verification-report/assets-physical-verification-report.component';
import { AssetsPopupConfirmationReportComponent } from './account-report/assets-popup-confirmation-report/assets-popup-confirmation-report.component';
import { AssetsTransferHistoryReportComponent } from './account-report/assets-transfer-history-report/assets-transfer-history-report.component';
import { UpdateBudgetComponent } from './analytic-report/update-budget/update-budget.component';
import { VarianceReportExcelComponent } from './analytic-report/variance-report-excel/variance-report-excel.component';
import { AssetTermsOfUsesComponent } from './dashboard/asset-terms-of-uses/asset-terms-of-uses.component';
import { KnowYourColleaugesComponent } from './user-details/know-your-colleauges/know-your-colleauges.component';
import { KnowYourClientsComponent } from './user-details/know-your-clients/know-your-clients.component';
import { MyHolidaysComponent } from './user-details/my-holidays/my-holidays.component';
import { ManageAnnouncementHistoryComponent } from './organization-setup/manage-announcement-history/manage-announcement-history.component';
import { MainDashboardComponent } from './dashboard/main-dashboard/main-dashboard.component';
import { AllPartnersDashboardComponent } from './dashboard/all-partners-dashboard-managing-partner/all-partners-dashboard/all-partners-dashboard.component';
import { ArticleVacancyComponent } from './master-data/article-vacancy/article-vacancy.component';
import { ReportListComponent } from './report-list/report-list.component';
import { MyTargetReportComponent } from './analytic-report/my-target-report/my-target-report.component';
import { UserDataListComponent } from './user-data-list/user-data-list.component';
import { MyReportListComponent } from './my-report-list/my-report-list.component';
import { MasterDataListComponent } from './master-data-list/master-data-list.component';
import { HrReportListComponent } from './hr-report-list/hr-report-list.component';
import { AccountReportListComponent } from './account-report-list/account-report-list.component';
import { MonthlyNewJoineeReportComponent } from './hr-report/monthly-new-joinee-report/monthly-new-joinee-report.component';
import { MonthlyLeftEmpReportComponent } from './hr-report/monthly-left-emp-report/monthly-left-emp-report.component';
import { TestComponent } from './test/test.component';
import { ManagementInformationSystemComponent } from './organization-setup/management-information-system/management-information-system.component';
import { DiaryDetailsClientWiseComponent } from './hr-report/diary-details-client-wise/diary-details-client-wise.component';
import { MisReportComponent } from './hr-report/mis-report/mis-report.component';
import { CommitmentLetterComponent } from './user-details/commitment-letter/commitment-letter.component';
import { ContractLetterComponent } from './user-details/contract-letter/contract-letter.component';
import { ServiceVerticalComponent } from './master-data/service-vertical/service-vertical.component';
import { ProbationCompleteReportComponent } from './hr-report/probation-complete-report/probation-complete-report.component';
import { ArticleshipEndReportComponent } from './hr-report/articleship-end-report/articleship-end-report.component';
import { ConsultantsEndReportComponent } from './hr-report/consultants-end-report/consultants-end-report.component';
import { WorkAnniversaeyReportComponent } from './hr-report/work-anniversaey-report/work-anniversaey-report.component';
import { IncompleteProfilesComponent } from './hr-report/incomplete-profiles/incomplete-profiles.component';
import { ITReportListComponent } from './IT-report-list/it-report-list/it-report-list.component';
import { CtcDetailsReportComponent } from './hr-report/ctc-details-report/ctc-details-report.component';
import { DpdpDeclarationComponent } from './analytic-report/independence/dpdp-declaration/dpdp-declaration.component';
import { MyDpdpDeclarationComponent } from './hr-report/independence/my-dpdp-declaration/my-dpdp-declaration.component';
import { AccessPrivilegeComponent } from './access-privilege/access-privilege.component';
import { PartnerReportListComponent } from './partner-report-list/partner-report-list.component';
import { LatestCtcDetailsReportComponent } from './hr-report/latest-ctc-details-report/latest-ctc-details-report.component';
import { LatestReportingPartnersReportComponent } from './hr-report/latest-reporting-partners-report/latest-reporting-partners-report.component';
import { PendingDiaryWeeksTeamComponent } from './manage-diary/pending-diary-weeks-team/pending-diary-weeks-team/pending-diary-weeks-team.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'under-construction', component: UnderConstructionComponent },
      // { path: 'my-diary', component: MydiaryComponent },
      { path: 'manage-profile', component: ProfileComponent },
      { path: 'manage-assignment', component: ManageAssignmentComponent },
      { path: 'manage-task', component: ManageTaskComponent },
      { path: 'manage-branch', component: ManageBranchComponent },
      {
        path: 'manage-financial-year',
        component: ManageFinancialYearComponent,
      },
      { path: 'manage-role', component: ManageDRoleComponent },
      { path: 'manage-designation', component: ManageDesignationComponent },
      { path: 'manage-location', component: ManageLocationComponent },
      { path: 'manage-client', component: ClientComponent },
      { path: 'conveyance-rates', component: ConveyanceRatesComponent },
      { path: 'standard-rates', component: StandardRatesComponent },
      { path: 'branch-holidays', component: BranchHolidaysComponent },
      { path: 'article-stipend', component: ArticleStipendComponent },
      { path: 'comapny-configuration', component: CompanyConfigComponent },
      {
        path: 'manpower-budget',
        component: ManpowerBudgetComponent,
        canDeactivate: [ComponentCanDeactivateGuard],
      },
      { path: 'my-diary', component: MyDiaryComponent },
      {
        path: 'my-pending-submission',
        component: MyPendingSubmissionComponent,
      },
      {
        path: 'my-pending-submission/:id',
        component: MyPendingSubmissionComponent,
      },
      { path: 'my-pending-approval', component: MyPendingApprovalComponent },
      { path: 'my-leaves', component: MyLeavesComponent },
      { path: 'ctc-details', component: CtcDetailsComponent },
      { path: 'official-details', component: OfficialDetailsComponent },
      { path: 'personal-details', component: PersonalDetailsComponent },
      { path: 'diary-details', component: DiaryDetailsComponent },
      { path: 'sr-my-diaries', component: MyDiariesComponent },
      { path: 'sr-my-leaves', component: MyLeavesDetailsComponent },
      { path: 'hr-my-leaves', component: EmpLeaveSummaryComponent },
      { path: 'salary-report', component: SalaryComponent },
      { path: 'stipend-report', component: StipendComponent },
      { path: 'penalty-summary-report', component: PenaltySummaryComponent },
      { path: 'annual-independence', component: AnnualComponent },
      { path: 'client-independence', component: ClientIndependenceComponent },
      { path: 'employee-independence', component: EmployeeComponent },
      { path: 'all-client-independence', component: AllClientComponent },
      { path: 'budget-report', component: BudgetComponent },
      { path: 'client-billing', component: ClientBillingComponent },
      { path: 'my-all-client', component: MyAllClientComponent },
      { path: 'my-annual', component: MyAnnualComponent },
      { path: 'my-client', component: MyClientComponent },
      { path: 'my-employee', component: MyEmployeeComponent },
      { path: 'my-salary-closing', component: MySalaryClosingComponent },
      { path: 'my-penalty-summary', component: MyPenaltySummaryComponent },
      {
        path: 'article-one-sixth-report',
        component: ArticleOneSixthReportComponent,
      },
      {
        path: 'my-article-one-sixth-report',
        component: MyArticleOneSixthReportComponent,
      },
      {
        path: 'my-unapproved-diaries',
        component: MyUnapprovedDiariesComponent,
      },
      {
        path: 'empanelment-report',
        component: EmpanelmentReportComponent,
      },
      {
        path: 'manage-announcement',
        component: ManageAnnouncementComponent,
      },
      {
        path: 'client-conveyance-summary',
        component: ClientConveyanceSummaryComponent,
      },
      {
        path: 'client-conveyance-assignment',
        component: ClientConveyanceAssignmentComponent,
      },
      {
        path: 'my-stipend-report',
        component: MyStipendReportComponent,
      },
      {
        path: 'monthly-conveyance-report',
        component: MonthlyConveyanceReportComponent,
      },
      {
        path: 'monthly-conveyance-detail-report',
        component: MonthlyConveyanceDetailReportComponent,
      },
      {
        path: 'overtime-report',
        component: OvertimeReportComponent,
      },
      {
        path: 'article-availability-report',
        component: ArticleAvailabilityReportComponent,
      },
      {
        path: 'create-folder',
        component: CreateFolderComponent,
      },
      {
        path: 'folder-menu',
        component: DocumentFolderMenuComponent,
      },
      {
        path: 'document-list',
        component: DocumentListComponent,
      },
      {
        path: 'document-management',
        component: DocumentManagementComponent,
      },
      {
        path: 'travel-sheet',
        component: TravelSheetComponent,
      },
      {
        path: 'my-pending-travel-sheet-approvals',
        component: MyPendingTravelSheetApprovalsComponent,
      },
      {
        path: 'submitted-sheets',
        component: SubmittedSheetsComponent,
      },
      {
        path: 'my-unapproved-travel-sheet',
        component: MyUnapprovedTravelSheetsComponent,
      },
      {
        path: 'budget-vs-actual-cost',
        component: BudgetVsActualCostReportComponent,
      },
      {
        path: 'my-budget-vs-actual-cost',
        component: BudgetVsActualCostReportComponent,
      },
      {
        path: 'bank-payment',
        component: BankPaymentReportComponent,
      },
      {
        path: 'salary-slip',
        component: SalarySlipReportComponent,
      },
      {
        path: 'article-debit-credit-hours',
        component: ArticleDebitCreditHoursComponent,
      },
      {
        path: 'all-independence-declaration',
        component: AllIndependenceDeclarationComponent,
      },
      {
        path: 'my-all-independence-declaration',
        component: MyAllIndependenceDeclarationComponent,
      },
      {
        path: 'annual-salary-report',
        component: AnnualSalaryReportComponent,
      },
      {
        path: '',
        component: MainDashboardComponent,
      },
      {
        path: 'exit-form',
        component: ExitFormComponent,
      },
      {
        path: 'exit-form-detail',
        component: ExitFormComponent,
      },
      {
        path: 'exit-form-summary',
        component: ExitFormSummaryComponent,
      },
      {
        path: 'annual-stipend-report',
        component: AnnualStipendReportComponent,
      },
      {
        path: 'expense-reimbursement-report',
        component: ExpenseReimbursementReportComponent,
      },
      {
        path: 'my-actual-task-report',
        component: MyActualTaskReportComponent,
      },
      {
        path: 'actual-task-report',
        component: MyActualTaskReportComponent,
      },
      {
        path: 'software-assets-management',
        component: SoftwareAssetsComponent,
      },
      {
        path: 'hardware-assets-management',
        component: HardwareAssetsComponent,
      },
      {
        path: 'physical-verification-report',
        component: AssetsPhysicalVerificationReportComponent,
      },
      {
        path: 'popup-confirmation-report',
        component: AssetsPopupConfirmationReportComponent,
      },
      {
        path: 'transfer-history-report',
        component: AssetsTransferHistoryReportComponent,
      },
      {
        path: 'update-budget-excel',
        component: UpdateBudgetComponent,
      },
      {
        path: 'variance-report-excel',
        component: VarianceReportExcelComponent,
      },
      {
        path: 'asset-terms-of-uses',
        component: AssetTermsOfUsesComponent,
      },
      {
        path: 'know-your-colleauge',
        component: KnowYourColleaugesComponent,
      },
      {
        path: 'know-your-clients',
        component: KnowYourClientsComponent,
      },
      {
        path: 'my-holidays-report',
        component: MyHolidaysComponent,
      },
      {
        path: 'manage-announcement-history',
        component: ManageAnnouncementHistoryComponent,
      },
      {
        path: 'main-dashboard',
        component: MainDashboardComponent,
      },
      {
        path: 'app-all-partners-dashboard',
        component: AllPartnersDashboardComponent,
      },
      {
        path: 'article-vacancy',
        component: ArticleVacancyComponent,
      },
      {
        path: 'report-list',
        component: ReportListComponent,
      },
      {
        path: 'my-target-report',
        component: MyTargetReportComponent,
      },
      {
        path: 'user-data-list',
        component: UserDataListComponent,
      },
      {
        path: 'my-report-list',
        component: MyReportListComponent,
      },
      {
        path: 'master-data-list',
        component: MasterDataListComponent,
      },
      {
        path: 'hr-report-list',
        component: HrReportListComponent,
      },
      {
        path: 'account-report-list',
        component: AccountReportListComponent,
      },
      {
        path: 'monthly-new-joinee-report',
        component: MonthlyNewJoineeReportComponent,
      },
      {
        path: 'monthly-left-employee-report',
        component: MonthlyLeftEmpReportComponent,
      },
      {
        path: 'management-information-system',
        component: ManagementInformationSystemComponent,
      },
      {
        path: 'diary-details-client-wise',
        component: DiaryDetailsClientWiseComponent,
      },
      {
        path: 'mis-report',
        component: MisReportComponent,
      },
      {
        path: 'commitment-letter',
        component: CommitmentLetterComponent,
      },
      {
        path: 'contract-letter',
        component: ContractLetterComponent,
      },
      {
        path: 'service-vertical',
        component: ServiceVerticalComponent,
      },
      {
        path: 'probation-complete-report',
        component: ProbationCompleteReportComponent,
      },
      {
        path: 'articleship-end-report',
        component: ArticleshipEndReportComponent,
      },
      {
        path: 'consultants-end-report',
        component: ConsultantsEndReportComponent,
      },
      {
        path: 'work-anniversaey-report',
        component: WorkAnniversaeyReportComponent,
      },
      {
        path: 'incomplete-profiles',
        component: IncompleteProfilesComponent,
      },
      {
        path: 'it-report-list',
        component: ITReportListComponent,
      },
      {
        path: 'ctc-details-report',
        component: CtcDetailsReportComponent,
      },
      {
        path: 'dpdp-declaration',
        component: DpdpDeclarationComponent,
      },
      {
        path: 'my-dpdp-declaration',
        component: MyDpdpDeclarationComponent,
      },
      {
        path: 'access-privilege',
        component: AccessPrivilegeComponent,
      },
      {
        path: 'partner-report-list',
        component: PartnerReportListComponent,
      },
      {
        path: 'latest-ctc-details-report',
        component: LatestCtcDetailsReportComponent,
      },
      {
        path: 'latest-reporting-partners',
        component: LatestReportingPartnersReportComponent,
      },
      {
        path: 'pending-diary-weeks-team',
        component: PendingDiaryWeeksTeamComponent,
      },
      {
        path: 'test',
        component: TestComponent,
      }
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
];


@NgModule({
  //imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
// 		.antMatchers("/","/index.html", "/assets/**","/favicon.ico","/*.js","/*.js.map","/*.css","/*.txt","/*.ttf","/*.woff2","/*.eot","/*.svg","/*.woff","/*.png","/*.jpg").permitAll()
